import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import config from "./config";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { ProjectProvider } from "./context/ProjectContext";
import { SignUp } from "./projects/shared/signUp/index";
import SignIn from "./projects/shared/signIn";
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: "UX_HTTP_API",
        endpoint: config.apiGateway.REACT_APP_API_URL,
        region: config.apiGateway.REGION,
      },
    ],
  },
});

// concatenate app name with stage and revision
/* document.title =
  process.env.REACT_APP_APP_NAME + " - " + config.meta.STAGE;
 */

const root = ReactDOM.createRoot(document.getElementById("root"));

// WRAP APP with <Authenticator> for authentication STIJN
root.render(
/*   <React.StrictMode>
 */    <BrowserRouter>

    <App gitRevision={config.meta.VERSION} stage={config.meta.STAGE} />

  </BrowserRouter>
/*   </React.StrictMode>
 */);
